import { render } from "./BingSession.vue?vue&type=template&id=bccea4ea&scoped=true"
import script from "./BingSession.vue?vue&type=script&lang=js"
export * from "./BingSession.vue?vue&type=script&lang=js"

import "./BingSession.vue?vue&type=style&index=0&id=bccea4ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bccea4ea"]])

export default __exports__